import { jsx as _jsx } from "react/jsx-runtime";
import { normalizeLegacyOperator } from "@aidkitorg/types/lib/admin-panel/filters";
import { Badge } from "../Badge";
export const operatorLabels = {
    equals: '=',
    not_equals: '≠',
    contains: 'contains',
    not_contains: 'does not contain',
    greater_than: '>',
    less_than: '<',
    after: 'after',
    before: 'before',
    exists: 'exists',
    not_exists: 'does not exist'
};
export const formatFieldName = (field, fieldLabels) => {
    if (fieldLabels && fieldLabels[field]) {
        return fieldLabels[field];
    }
    if (field === '__synthetic_uid__') {
        return 'uid';
    }
    if (field.startsWith('__') && field.endsWith('__')) {
        return field.replace(/__/g, '').replace(/_/g, ' ');
    }
    return field.replace(/_/g, ' ');
};
export const formatCondition = (condition, fieldLabels, operatorLabelOverrides, formatValue) => {
    const fieldName = formatFieldName(condition.field, fieldLabels);
    const labels = operatorLabelOverrides ?? operatorLabels;
    const normalizedOperator = normalizeLegacyOperator(condition.operator);
    const operator = labels[normalizedOperator] || normalizedOperator;
    if (normalizedOperator === 'exists' || normalizedOperator === 'not_exists') {
        return `${fieldName} ${operator}`;
    }
    if (condition.value) {
        let displayValue = condition.value;
        if (condition.field === 'applicant_group') {
            try {
                const parsed = JSON.parse(condition.value);
                if (parsed.name) {
                    displayValue = parsed.name;
                }
            }
            catch {
            }
        }
        else if (formatValue) {
            displayValue = formatValue(condition.field, condition.value) ?? displayValue;
        }
        return `${fieldName} ${operator} "${displayValue}"`;
    }
    return `${fieldName} ${operator}`;
};
export const renderFilterGroup = (group, fieldLabels, isNested = false, size = 'default', labels, onRemove, path = []) => {
    const badges = [];
    const pathKey = path.join('-');
    const logicLabel = group.logic === 'or'
        ? (labels?.or ?? group.logic)
        : (labels?.and ?? group.logic);
    if (isNested) {
        badges.push(_jsx("span", { className: `text-gray-600 font-medium self-center ${size === 'small' ? 'text-xs' : 'text-sm'}`, children: "(" }, `open-paren-${pathKey}`));
    }
    group.conditions.forEach((condition, index) => {
        const conditionPath = [...path, index];
        const conditionKey = conditionPath.join('-');
        if (index > 0) {
            badges.push(_jsx(Badge, { variant: "info", className: `uppercase font-semibold ${size === 'small' ? 'text-xs' : 'text-xs'}`, children: logicLabel }, `logic-${conditionKey}`));
        }
        if ('logic' in condition) {
            const nestedBadges = renderFilterGroup(condition, fieldLabels, true, size, labels, onRemove, conditionPath);
            badges.push(...nestedBadges);
        }
        else {
            badges.push(_jsx(Badge, { className: size === 'small' ? 'text-xs' : '', dismissable: !!onRemove, onDismiss: onRemove ? () => onRemove(conditionPath) : undefined, children: formatCondition(condition, fieldLabels, labels?.operatorLabels, labels?.formatValue) }, `condition-${conditionKey}`));
        }
    });
    if (isNested) {
        badges.push(_jsx("span", { className: `text-gray-600 font-medium self-center ${size === 'small' ? 'text-xs' : 'text-sm'}`, children: ")" }, `close-paren-${pathKey}`));
    }
    return badges;
};
